/**
 * @deprecated This component is considered very legacy and should not be used.
 * It is recommended to avoid any further use of this component due to its outdated nature.
 * Consider using modern alternative instead such as CheckBoxArray. See Example in shared/components/Tables/Columns
 *
 * @param {Object} checkboxes
 * @param {String} parentName
 * @return {*}
 */
export const findNested = (checkboxes, parentName) => {
  const nested = (parentName) => {
    let children = Object.keys(checkboxes).filter((key) => checkboxes[key].parent === parentName);
    const result = [];
    children.forEach((childName) => {
// @ts-ignore TODO: FIN-32798 strictNullChecks
      result.push(childName);
      let items = Object.keys(checkboxes).filter((key) => checkboxes[key].parent === childName);
      if (items.length) {
// @ts-ignore TODO: FIN-32798 strictNullChecks
        items.forEach((checkbox) => result.push(checkbox, ...nested(checkbox)));
      }
    });
    return result || children;
  };
  return nested(parentName);
};

/**
 * @deprecated This component is considered very legacy and should not be used.
 * It is recommended to avoid any further use of this component due to its outdated nature.
 * Consider using modern alternative instead such as CheckBoxArray. See Example in shared/components/Tables/Columns
 *
 * @return {Object}
 */
export const getCheckboxChildren = (checkboxes, name) => (
  findNested(checkboxes, name).reduce((obj, key) => ({ ...obj, [key]: checkboxes[key] }), {})
);
